(function(){
const te=new TextEncoder();
function xmlEsc(v){
return String(v??'')
.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
.replace(/"/g,'&quot;').replace(/'/g,'&apos;');
}
function colName(n){
let s='';
while(n>0){n--;s=String.fromCharCode(65+(n%26))+s;n=Math.floor(n/26);}
return s;
}
function crc32(bytes){
let c=0xffffffff;
for(let i=0;i<bytes.length;i++){
c^=bytes[i];
for(let k=0;k<8;k++) c=(c>>>1)^((c&1)?0xedb88320:0);
}
return (c^0xffffffff)>>>0;
}
function u16(n){return new Uint8Array([n&255,(n>>>8)&255]);}
function u32(n){return new Uint8Array([n&255,(n>>>8)&255,(n>>>16)&255,(n>>>24)&255]);}
function concat(arrs){
let len=0;arrs.forEach(a=>len+=a.length);
const out=new Uint8Array(len);let p=0;
arrs.forEach(a=>{out.set(a,p);p+=a.length;});
return out;
}
// ZIP "store" method (no compression) – valid XLSX container, fully offline.
function makeZip(files){
const locals=[], centrals=[];
let offset=0;
Object.entries(files).forEach(([name,content])=>{
const nameB=te.encode(name), data=content instanceof Uint8Array?content:te.encode(content);
const crc=crc32(data);
const local=concat([
u32(0x04034b50),u16(20),u16(0),u16(0),u16(0),u16(33),
u32(crc),u32(data.length),u32(data.length),u16(nameB.length),u16(0),nameB,data
]);
locals.push(local);
const central=concat([
u32(0x02014b50),u16(20),u16(20),u16(0),u16(0),u16(0),u16(33),
u32(crc),u32(data.length),u32(data.length),u16(nameB.length),u16(0),
u16(0),u16(0),u16(0),u32(0),u32(offset),nameB
]);
centrals.push(central);
offset+=local.length;
});
const centralData=concat(centrals);
const localData=concat(locals);
const end=concat([
u32(0x06054b50),u16(0),u16(0),u16(centrals.length),u16(centrals.length),
u32(centralData.length),u32(localData.length),u16(0)
]);
return concat([localData,centralData,end]);
}
function deliveryLabel(k){
return ({
lp:'LP',omniva:'OMNIVA',venipak:'VENIPAK',dpd:'DPD',
courier:'VENIPAK K.',bus:'Autobusų st.',pickup:'Vietoje'
}[String(k||'').trim().toLowerCase()]||String(k||''));
}
function num(v){
if(typeof proMoney==='function') return proMoney(v);
return Number(String(v??'').replace(/[^0-9,.-]/g,'').replace(',','.'))||0;
}
function cellXml(v,style=4){
if(v===null||v===undefined||v==='') return `<c s="${style}" t="inlineStr"><is><t></t></is></c>`;
if(typeof v==='number' && Number.isFinite(v)) return `<c s="${style}"><v>${v}</v></c>`;
return `<c s="${style}" t="inlineStr"><is><t>${xmlEsc(v)}</t></is></c>`;
}
function rowXml(values,rowNo,styleFn){
const cells=values.map((v,i)=>{
const style=styleFn?styleFn(v,i,rowNo):4;
const ref=colName(i+1)+rowNo;
if(v===null||v===undefined||v==='') return `<c r="${ref}" s="${style}" t="inlineStr"><is><t></t></is></c>`;
if(typeof v==='number' && Number.isFinite(v)) return `<c r="${ref}" s="${style}"><v>${v}</v></c>`;
return `<c r="${ref}" s="${style}" t="inlineStr"><is><t>${xmlEsc(v)}</t></is></c>`;
}).join('');
return `<row r="${rowNo}">${cells}</row>`;
}
function sheetXml(opts){
const {
title,subtitle,headers,rows,widths,styleForRow,
filter=true,freeze=true,extraRows=[],landscape=true
}=opts;
const totalCols=Math.max(headers?.length||1,widths?.length||1);
const lastCol=colName(totalCols);
let r=1, xmlRows=[];
// Title: thick border across the whole merged width.
const titleCells=[];
for(let c=1;c<=totalCols;c++){
const ref=colName(c)+r;
if(c===1)titleCells.push(`<c r="${ref}" s="1" t="inlineStr"><is><t>${xmlEsc(title)}</t></is></c>`);
else titleCells.push(`<c r="${ref}" s="10" t="inlineStr"><is><t></t></is></c>`);
}
xmlRows.push(`<row r="${r}" ht="28" customHeight="1">${titleCells.join('')}</row>`); r++;
// Subtitle: also boxed with a strong border.
const subtitleCells=[];
for(let c=1;c<=totalCols;c++){
const ref=colName(c)+r;
if(c===1)subtitleCells.push(`<c r="${ref}" s="2" t="inlineStr"><is><t>${xmlEsc(subtitle||'')}</t></is></c>`);
else subtitleCells.push(`<c r="${ref}" s="11" t="inlineStr"><is><t></t></is></c>`);
}
xmlRows.push(`<row r="${r}" ht="20" customHeight="1">${subtitleCells.join('')}</row>`); r++;
// Spacer
xmlRows.push(`<row r="${r}"></row>`); r++;
const headerRow=r;
// Alternating gradient direction: A->B, B->A, A->B...
xmlRows.push(rowXml(headers,r,(v,i)=>i%2===0?3:7)); r++;
rows.forEach((row,idx)=>{
const actualRow=r;
xmlRows.push(rowXml(row,actualRow,(v,i)=>styleForRow?styleForRow(row,i,idx):4));
r++;
});
extraRows.forEach(row=>{
xmlRows.push(rowXml(row,r,()=>4));r++;
});
const lastDataRow=Math.max(headerRow,r-1);
const cols=(widths||[]).map((w,i)=>`<col min="${i+1}" max="${i+1}" width="${w}" customWidth="1"/>`).join('');
return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">
<sheetViews><sheetView workbookViewId="0">${freeze?`<pane ySplit="${headerRow}" topLeftCell="A${headerRow+1}" activePane="bottomLeft" state="frozen"/>`:''}</sheetView></sheetViews>
<sheetFormatPr defaultRowHeight="19"/>
<cols>${cols}</cols>
<sheetData>${xmlRows.join('')}</sheetData>
${filter?`<autoFilter ref="A${headerRow}:${lastCol}${lastDataRow}"/>`:''}
<mergeCells count="2"><mergeCell ref="A1:${lastCol}1"/><mergeCell ref="A2:${lastCol}2"/></mergeCells>
<pageMargins left="0.25" right="0.25" top="0.4" bottom="0.4" header="0.2" footer="0.2"/>
<pageSetup orientation="${landscape?'landscape':'portrait'}" fitToWidth="1" fitToHeight="0"/>
</worksheet>`;
}
function stylesXml(cfg){
const accent=(cfg.accentColor||'#ff8a00').replace('#','').toUpperCase();
const accent2=(cfg.accentColor2||'#ff5f9e').replace('#','').toUpperCase();
return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">
<numFmts count="2">
<numFmt numFmtId="164" formatCode="#,##0.00 [$€-lt-LT]"/>
<numFmt numFmtId="165" formatCode="0.0%"/>
</numFmts>
<fonts count="5">
<font><sz val="11"/><color rgb="FF111111"/><name val="Aptos"/></font>
<font><b/><sz val="18"/><color rgb="FF111111"/><name val="Aptos Display"/></font>
<font><b/><sz val="11"/><color rgb="FF111111"/><name val="Aptos"/></font>
<font><b/><sz val="11"/><color rgb="FF111111"/><name val="Aptos"/></font>
<font><i/><sz val="10"/><color rgb="FF555555"/><name val="Aptos"/></font>
</fonts>
<fills count="5">
<fill><patternFill patternType="none"/></fill>
<fill><patternFill patternType="gray125"/></fill>

<fill>
<gradientFill type="linear" degree="0">
<stop position="0"><color rgb="FF${accent}"/></stop>
<stop position="1"><color rgb="FF${accent2}"/></stop>
</gradientFill>
</fill>

<fill>
<gradientFill type="linear" degree="0">
<stop position="0"><color rgb="FF${accent2}"/></stop>
<stop position="1"><color rgb="FF${accent}"/></stop>
</gradientFill>
</fill>
<fill><patternFill patternType="solid"><fgColor rgb="FFFFFFFF"/></patternFill></fill>
</fills>
<borders count="3">
<border/>
<border>
<left style="thin"><color rgb="FF333333"/></left>
<right style="thin"><color rgb="FF333333"/></right>
<top style="thin"><color rgb="FF333333"/></top>
<bottom style="thin"><color rgb="FF333333"/></bottom>
</border>
<border>
<left style="medium"><color rgb="FF222222"/></left>
<right style="medium"><color rgb="FF222222"/></right>
<top style="medium"><color rgb="FF222222"/></top>
<bottom style="medium"><color rgb="FF222222"/></bottom>
</border>
</borders>
<cellStyleXfs count="1">
<xf numFmtId="0" fontId="0" fillId="0" borderId="0"/>
</cellStyleXfs>
<cellXfs count="13">

<xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>

<xf numFmtId="0" fontId="1" fillId="2" borderId="2" xfId="0"><alignment horizontal="left" vertical="center"/></xf>

<xf numFmtId="0" fontId="4" fillId="4" borderId="2" xfId="0"><alignment horizontal="left" vertical="center"/></xf>

<xf numFmtId="0" fontId="2" fillId="2" borderId="1" xfId="0"><alignment horizontal="center" vertical="center" wrapText="1"/></xf>

<xf numFmtId="0" fontId="3" fillId="4" borderId="1" xfId="0"><alignment horizontal="center" vertical="center" wrapText="1"/></xf>

<xf numFmtId="164" fontId="3" fillId="4" borderId="1" xfId="0"><alignment horizontal="center" vertical="center"/></xf>

<xf numFmtId="165" fontId="3" fillId="4" borderId="1" xfId="0"><alignment horizontal="center" vertical="center"/></xf>

<xf numFmtId="0" fontId="2" fillId="3" borderId="1" xfId="0"><alignment horizontal="center" vertical="center" wrapText="1"/></xf>

<xf numFmtId="0" fontId="2" fillId="2" borderId="1" xfId="0"><alignment horizontal="center" vertical="center"/></xf>

<xf numFmtId="0" fontId="2" fillId="3" borderId="1" xfId="0"><alignment horizontal="center" vertical="center"/></xf>

<xf numFmtId="0" fontId="1" fillId="2" borderId="2" xfId="0"><alignment horizontal="center" vertical="center"/></xf>

<xf numFmtId="0" fontId="4" fillId="4" borderId="2" xfId="0"><alignment horizontal="center" vertical="center"/></xf>

<xf numFmtId="164" fontId="3" fillId="4" borderId="1" xfId="0"><alignment horizontal="center" vertical="center"/></xf>
</cellXfs>
<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>
</styleSheet>`;
}
async function exportTrackingExcel(fromDate='',toDate=''){
const allRows=(typeof getTrackingInfo==='function'?getTrackingInfo():[]).filter(r=>r&&(r.no||r.date||r.order||r.buyer||r.sum||r.file));
const rows=allRows.filter(r=>{
const d=String(r.date||'');
if(fromDate && (!d || d<fromDate))return false;
if(toDate && (!d || d>toDate))return false;
return true;
});
if(!rows.length){alert('Pasirinktame laikotarpyje nėra sąskaitų eksportui.');return false;}
const cfg=typeof getAppSettings==='function'?getAppSettings():{};
const products=typeof getProducts==='function'?getProducts():[];
const clients=typeof getClients==='function'?getClients():[];
const now=new Date();
const rangeText=(fromDate||toDate)?` · Laikotarpis ${fromDate||'—'} – ${toDate||'—'}`:'';
const subtitle=`${cfg.sellerName||'Jūsų įmonės pavadinimas'}${cfg.sellerBrand?' · '+cfg.sellerBrand:''} · Eksportuota ${now.toLocaleString('lt-LT')}${rangeText}`;
// SĄSKAITOS
const invoiceRows=rows.map(r=>{
const sum=num(r.sum);
const status=r.status||({'Taip':'Apmokėta','Ne':'Neapmokėta'}[r.paid]||'Apmokėta');
const received=status==='Apmokėta'?sum:num(r.received);
return [r.no||'',r.date||'',r.order||'',r.buyer||'',sum,status,received,Math.max(0,sum-received),deliveryLabel(r.deliveryMethod||''),r.file||''];
});
const invoicesSheet=sheetXml({
title:'SĄSKAITŲ REGISTRAS',subtitle,
headers:['SF Nr.','Data','Užsakymo Nr.','Pirkėjas','Suma','Statusas','Gauta','Likutis','Pristatymas','Failo pavadinimas'],
rows:invoiceRows,
widths:[22,14,18,29,14,16,14,14,18,42],
styleForRow:(row,i)=>{
if([4,6,7].includes(i)) return 5;
return 4;
}
});
// PREKĖS
const productRows=[];
rows.forEach(r=>{
(r.items||[]).forEach(it=>{
if(!it.name)return;
const cat=products.find(p=>p.name===it.name)||{};
const qty=Number(it.qty)||0, price=num(it.price), discount=Math.max(0,Number(it.discount)||0);
const cost=num(it.cost)||num(cat.cost), revenue=qty*price*(1-discount/100), profit=revenue-(qty*cost);
productRows.push([r.no||'',r.date||'',r.buyer||'',it.name,cat.category||'',cat.sku||'',qty,price,discount/100,cost,profit]);
});
});
if(!productRows.length) productRows.push(['','','','Prekių detalizacija kaupsis nuo SF su prekių snapshotu.','','',0,0,0,0,0]);
const productsSheet=sheetXml({
title:'PARDUOTŲ PREKIŲ DETALIZACIJA',subtitle:'Duomenys iš registruotų sąskaitų prekių snapshotų',
headers:['SF Nr.','Data','Pirkėjas','Prekė','Kategorija','SKU','Kiekis','Vnt. kaina','Nuolaida %','Savikaina / vnt.','Bruto pelnas'],
rows:productRows,
widths:[22,14,28,40,22,18,10,15,13,17,17],
styleForRow:(row,i)=>[7,9,10].includes(i)?5:(i===8?6:4)
});
// SUVESTINĖ
let total=0,got=0,cost=0;
const months={},prodAgg={},delAgg={};
rows.forEach(r=>{
const s=num(r.sum),st=r.status||'Apmokėta'; total+=s; got+=st==='Apmokėta'?s:num(r.received);
const m=String(r.date||'').slice(0,7)||'Be datos'; months[m]=(months[m]||0)+s;
const dl=deliveryLabel(r.deliveryMethod||'Nenurodyta'); delAgg[dl]=(delAgg[dl]||0)+1;
(r.items||[]).forEach(it=>{
if(it.name)prodAgg[it.name]=(prodAgg[it.name]||0)+(Number(it.qty)||0);
const cat=products.find(p=>p.name===it.name)||{};
cost+=(num(it.cost)||num(cat.cost))*(Number(it.qty)||0);
});
});
const profit=total-cost, margin=total?profit/total:0;
const summaryRows=[
['Išrašyta SF',rows.length],
['Pardavimai',total],
['Gauta',got],
['Likutis',Math.max(0,total-got)],
['Savikaina',cost],
['Bruto pelnas',profit],
['Marža',margin],
['',''],
['PARDAVIMAI PAGAL MĖNESĮ',''],
...Object.entries(months).sort().map(([m,v])=>[m,v]),
['',''],
['TOP PREKĖS','Kiekis'],
...Object.entries(prodAgg).sort((a,b)=>b[1]-a[1]).slice(0,10),
['',''],
['PRISTATYMO BŪDAI','Kiekis'],
...Object.entries(delAgg).sort((a,b)=>b[1]-a[1])
];
const summarySheet=sheetXml({
title:'VERSLO SUVESTINĖ',subtitle:'Automatiškai apskaičiuota iš SEKIMO INFO ir prekių snapshotų',
headers:['Rodiklis','Reikšmė'],
rows:summaryRows,
widths:[38,20],
filter:false,freeze:false,landscape:false,
styleForRow:(row,i)=>{
if(['PARDAVIMAI PAGAL MĖNESĮ','TOP PREKĖS','PRISTATYMO BŪDAI'].includes(row[0])) return i%2===0?8:9;
if(row[0]==='Marža'&&i===1)return 6;
if(['Pardavimai','Gauta','Likutis','Savikaina','Bruto pelnas'].includes(row[0])&&i===1)return 5;
return 4;
}
});
// KLIENTAI
const agg={};
rows.forEach(r=>{
const k=r.buyer||'Nežinomas';
if(!agg[k])agg[k]={count:0,total:0,last:''};
agg[k].count++;agg[k].total+=num(r.sum);
if(String(r.date||'')>agg[k].last)agg[k].last=String(r.date||'');
});
const clientRows=Object.entries(agg).sort((a,b)=>b[1].total-a[1].total).map(([name,a])=>{
const crm=clients.find(x=>x.name===name)||null;
const invoiceRowsForClient=rows.filter(r=>String(r.buyer||'')===name).sort((x,y)=>String(y.date||'').localeCompare(String(x.date||'')));
const snap=invoiceRowsForClient.find(r=>r.buyerDetails && (r.buyerDetails.address||r.buyerDetails.phone||r.buyerDetails.email))?.buyerDetails||{};
const c=crm||snap;
return [name,c.address||'',c.phone||'',c.email||'',crm?.code||'',crm?.vat||'',a.count,a.total,a.last];
});
const clientsSheet=sheetXml({
title:'KLIENTŲ SUVESTINĖ',subtitle:'Klientų kontaktai ir pirkimų statistika',
headers:['Klientas','Adresas','Telefonas','El. paštas','Įmonės kodas','PVM kodas','SF kiekis','Pirkimų suma','Paskutinis pirkimas'],
rows:clientRows,
widths:[28,36,18,30,18,18,12,17,18],
styleForRow:(row,i)=>i===7?5:4
});
const sheetNames=['SĄSKAITOS','PREKĖS','SUVESTINĖ','KLIENTAI'];
const sheetXmls=[invoicesSheet,productsSheet,summarySheet,clientsSheet];
const workbookSheets=sheetNames.map((n,i)=>`<sheet name="${xmlEsc(n)}" sheetId="${i+1}" r:id="rId${i+1}"/>`).join('');
const workbookRels=sheetNames.map((n,i)=>`<Relationship Id="rId${i+1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet${i+1}.xml"/>`).join('');
const files={
'[Content_Types].xml':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>${sheetNames.map((_,i)=>`<Override PartName="/xl/worksheets/sheet${i+1}.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>`).join('')}<Override PartName="/docProps/core.xml" ContentType="application/vnd.openxmlformats-package.core-properties+xml"/><Override PartName="/docProps/app.xml" ContentType="application/vnd.openxmlformats-officedocument.extended-properties+xml"/></Types>`,
'_rels/.rels':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/><Relationship Id="rId2" Type="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties" Target="docProps/core.xml"/><Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties" Target="docProps/app.xml"/></Relationships>`,
'xl/workbook.xml':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><sheets>${workbookSheets}</sheets></workbook>`,
'xl/_rels/workbook.xml.rels':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">${workbookRels}<Relationship Id="rId${sheetNames.length+1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/></Relationships>`,
'xl/styles.xml':stylesXml(cfg),
'docProps/core.xml':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><cp:coreProperties xmlns:cp="http://schemas.openxmlformats.org/package/2006/metadata/core-properties" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"><dc:title>MOGA SF PRO – Excel eksportas</dc:title><dc:creator>Karolis Navickas / MOGA SF PRO v1.0</dc:creator><cp:lastModifiedBy>MOGA SF PRO v1.0</cp:lastModifiedBy><dcterms:created xsi:type="dcterms:W3CDTF">${now.toISOString()}</dcterms:created><dcterms:modified xsi:type="dcterms:W3CDTF">${now.toISOString()}</dcterms:modified></cp:coreProperties>`,
'docProps/app.xml':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Properties xmlns="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties" xmlns:vt="http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"><Application>MOGA SF PRO v1.0</Application></Properties>`
};
sheetXmls.forEach((x,i)=>files[`xl/worksheets/sheet${i+1}.xml`]=x);
const zip=makeZip(files);
const blob=new Blob([zip],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
const a=document.createElement('a');
a.href=URL.createObjectURL(blob);
const rangeFile=(fromDate&&toDate)?`_${fromDate}_${toDate}`:'';
a.download=`SF_Excel${rangeFile}_${typeof backupStamp==='function'?backupStamp():now.toISOString().slice(0,10)}.xlsx`;
document.body.appendChild(a);a.click();a.remove();
setTimeout(()=>URL.revokeObjectURL(a.href),1500);
return true;
}

async function exportInventoryExcel(){
  const inv=window.MOGA_INVENTORY;
  if(!inv){alert('Sandėlio modulis neįkeltas.');return false;}

  const products=inv.products?.()||[];
  const moves=inv.getMoves?.()||[];
  const store=inv.getStore?.()||{settings:{},records:{}};
  const cfg=typeof getAppSettings==='function'?getAppSettings():{};
  const now=new Date();
  const subtitle=`${cfg.sellerName||'Jūsų įmonės pavadinimas'}${cfg.sellerBrand?' · '+cfg.sellerBrand:''} · Eksportuota ${now.toLocaleString('lt-LT')}`;

  const statusLabel=(p,r)=>{
    const st=inv.status?.(p,r);
    return st?.label||'—';
  };

  let totalUnits=0,totalCost=0,totalRetail=0,reserved=0,available=0,attention=0;
  const stockRows=products.map(p=>{
    const r=inv.getRecord?.(p.inventoryId,false)||{qty:0,reserved:0,min:0,target:0,location:'',barcode:''};
    const qty=num(r.qty),res=num(r.reserved),av=qty-res,cost=num(p.cost),price=num(p.price);
    totalUnits+=qty;reserved+=res;available+=av;totalCost+=qty*cost;totalRetail+=qty*price;
    const st=inv.status?.(p,r);if(st&&['low','out'].includes(st.key))attention++;
    return [
      p.name||'',p.sku||'',p.category||'',statusLabel(p,r),
      qty,res,av,num(r.min),num(r.target),cost,qty*cost,price,qty*price,
      r.location||'',r.barcode||'',st?.reason||''
    ];
  });

  const stockSheet=sheetXml({
    title:'SANDĖLIO LIKUČIAI',
    subtitle,
    headers:['Prekė','SKU','Kategorija','Būsena','Likutis','Rezervuota','Galima','Min.','Tikslinis','Savikaina / vnt.','Sandėlio vertė','Pardavimo kaina','Pardavimo vertė','Vieta','Barkodas','Pastaba / riba'],
    rows:stockRows,
    widths:[40,18,28,14,11,12,11,9,11,17,18,17,19,18,20,34],
    styleForRow:(row,i)=>[9,10,11,12].includes(i)?5:4
  });

  const moveRows=moves.slice().sort((a,b)=>String(b.date||b.createdAt||'').localeCompare(String(a.date||a.createdAt||''))).map(m=>{
    const p=products.find(x=>x.inventoryId===m.productId)||{};
    const type=({
      inbound:'Priėmimas',writeoff:'Nurašymas',sale:'Pardavimas / SF',
      'invoice-update':'SF pakeitimas','invoice-return':'SF grąžinimas',
      'count-adjust':'Inventorizacija',purchase:'Pirkimas',
      'customer-return':'Kliento grąžinimas','return-cancel':'Atšauktas grąžinimas'
    })[m.type]||m.type||'Koregavimas';
    return [
      String(m.date||m.createdAt||'').replace('T',' ').slice(0,19),
      p.name||'',p.sku||'',type,num(m.delta),num(m.before),num(m.after),
      m.reference||'',m.note||'',num(m.unitCost),num(m.delta)*num(m.unitCost)
    ];
  });

  const movesSheet=sheetXml({
    title:'SANDĖLIO JUDĖJIMŲ ISTORIJA',
    subtitle,
    headers:['Data','Prekė','SKU','Tipas','Pokytis','Prieš','Po','Nuoroda','Pastaba','Savikaina','Pokyčio vertė'],
    rows:moveRows.length?moveRows:[['','','','Judėjimų dar nėra.',0,0,0,'','',0,0]],
    widths:[21,40,18,22,12,11,11,22,40,15,18],
    styleForRow:(row,i)=>[9,10].includes(i)?5:4
  });

  const summaryRows=[
    ['Katalogo prekės',products.length],
    ['Faktinis sandėlio likutis',totalUnits],
    ['Rezervuota',reserved],
    ['Galima parduoti',available],
    ['Reikia dėmesio',attention],
    ['Sandėlio savikaina',totalCost],
    ['Pardavimo vertė',totalRetail],
    ['Potencialus skirtumas',totalRetail-totalCost],
    ['',''],
    ['LIKUČIŲ PERSPĖJIMO REŽIMAS',''],
    ['Režimas',({
      individual:'Pagal kiekvienos prekės Min.',
      quantity:'Pagal bendrą kiekį',
      percent:'Pagal % nuo tikslinio kiekio',
      off:'Išjungta'
    })[store.settings?.lowStockMode]||'Pagal kiekvienos prekės Min.'],
    ['Bendra kiekio riba',num(store.settings?.lowStockQty)],
    ['Procentinė riba',num(store.settings?.lowStockPercent)/100],
    ['Taikymas',store.settings?.lowStockScope==='selected'?'Tik pasirinktoms prekėms':'Visoms prekėms']
  ];

  const summarySheet=sheetXml({
    title:'SANDĖLIO SUVESTINĖ',
    subtitle:'Automatiškai apskaičiuota pagal esamą sandėlio būseną',
    headers:['Rodiklis','Reikšmė'],
    rows:summaryRows,
    widths:[42,28],
    filter:false,freeze:false,landscape:false,
    styleForRow:(row,i)=>{
      if(row[0]==='LIKUČIŲ PERSPĖJIMO REŽIMAS')return i%2===0?8:9;
      if(['Sandėlio savikaina','Pardavimo vertė','Potencialus skirtumas'].includes(row[0])&&i===1)return 5;
      if(row[0]==='Procentinė riba'&&i===1)return 6;
      return 4;
    }
  });

  const sheetNames=['LIKUČIAI','JUDĖJIMAI','SUVESTINĖ'];
  const sheetXmls=[stockSheet,movesSheet,summarySheet];
  const workbookSheets=sheetNames.map((name,i)=>`<sheet name="${xmlEsc(name)}" sheetId="${i+1}" r:id="rId${i+1}"/>`).join('');
  const workbookRels=sheetNames.map((name,i)=>`<Relationship Id="rId${i+1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet${i+1}.xml"/>`).join('');

  const files={
    '[Content_Types].xml':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>${sheetNames.map((_,i)=>`<Override PartName="/xl/worksheets/sheet${i+1}.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>`).join('')}<Override PartName="/docProps/core.xml" ContentType="application/vnd.openxmlformats-package.core-properties+xml"/><Override PartName="/docProps/app.xml" ContentType="application/vnd.openxmlformats-officedocument.extended-properties+xml"/></Types>`,
    '_rels/.rels':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/><Relationship Id="rId2" Type="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties" Target="docProps/core.xml"/><Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties" Target="docProps/app.xml"/></Relationships>`,
    'xl/workbook.xml':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><sheets>${workbookSheets}</sheets></workbook>`,
    'xl/_rels/workbook.xml.rels':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">${workbookRels}<Relationship Id="rId${sheetNames.length+1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/></Relationships>`,
    'xl/styles.xml':stylesXml(cfg),
    'docProps/core.xml':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><cp:coreProperties xmlns:cp="http://schemas.openxmlformats.org/package/2006/metadata/core-properties" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"><dc:title>MOGA SF PREMIUM – Sandėlio Excel eksportas</dc:title><dc:creator>MOGA SF PREMIUM</dc:creator><cp:lastModifiedBy>MOGA SF PREMIUM</cp:lastModifiedBy><dcterms:created xsi:type="dcterms:W3CDTF">${now.toISOString()}</dcterms:created><dcterms:modified xsi:type="dcterms:W3CDTF">${now.toISOString()}</dcterms:modified></cp:coreProperties>`,
    'docProps/app.xml':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Properties xmlns="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties" xmlns:vt="http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"><Application>MOGA SF PREMIUM</Application></Properties>`
  };

  sheetXmls.forEach((x,i)=>files[`xl/worksheets/sheet${i+1}.xml`]=x);

  const zip=makeZip(files);
  const blob=new Blob([zip],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
  const a=document.createElement('a');
  a.href=URL.createObjectURL(blob);
  a.download=`SF_Sandelis_${typeof backupStamp==='function'?backupStamp():now.toISOString().slice(0,10)}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(()=>URL.revokeObjectURL(a.href),1500);
  return true;
}
window.exportInventoryExcel=exportInventoryExcel;



function safeSheetName(v,used){
let base=String(v||'Lapas').replace(/[\\/*?:\[\]]/g,' ').trim().slice(0,31)||'Lapas',name=base,i=2;
while(used.has(name)){const suf=` ${i++}`;name=(base.slice(0,31-suf.length)+suf)}used.add(name);return name;
}
function downloadWorkbook(sheetDefs,filename,title='MOGA SF PREMIUM – Apskaitos Excel'){
const cfg=typeof getAppSettings==='function'?getAppSettings():{},now=new Date(),used=new Set();
const defs=sheetDefs.map(x=>({...x,name:safeSheetName(x.name,used)}));
const sheetNames=defs.map(x=>x.name),sheetXmls=defs.map(x=>sheetXml(x));
const workbookSheets=sheetNames.map((n,i)=>`<sheet name="${xmlEsc(n)}" sheetId="${i+1}" r:id="rId${i+1}"/>`).join('');
const workbookRels=sheetNames.map((n,i)=>`<Relationship Id="rId${i+1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet${i+1}.xml"/>`).join('');
const files={
'[Content_Types].xml':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>${sheetNames.map((_,i)=>`<Override PartName="/xl/worksheets/sheet${i+1}.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>`).join('')}<Override PartName="/docProps/core.xml" ContentType="application/vnd.openxmlformats-package.core-properties+xml"/><Override PartName="/docProps/app.xml" ContentType="application/vnd.openxmlformats-officedocument.extended-properties+xml"/></Types>`,
'_rels/.rels':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/><Relationship Id="rId2" Type="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties" Target="docProps/core.xml"/><Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties" Target="docProps/app.xml"/></Relationships>`,
'xl/workbook.xml':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><sheets>${workbookSheets}</sheets></workbook>`,
'xl/_rels/workbook.xml.rels':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">${workbookRels}<Relationship Id="rId${sheetNames.length+1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/></Relationships>`,
'xl/styles.xml':stylesXml(cfg),
'docProps/core.xml':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><cp:coreProperties xmlns:cp="http://schemas.openxmlformats.org/package/2006/metadata/core-properties" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"><dc:title>${xmlEsc(title)}</dc:title><dc:creator>MOGA SF PREMIUM</dc:creator><cp:lastModifiedBy>MOGA SF PREMIUM</cp:lastModifiedBy><dcterms:created xsi:type="dcterms:W3CDTF">${now.toISOString()}</dcterms:created><dcterms:modified xsi:type="dcterms:W3CDTF">${now.toISOString()}</dcterms:modified></cp:coreProperties>`,
'docProps/app.xml':`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Properties xmlns="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties" xmlns:vt="http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"><Application>MOGA SF PREMIUM</Application></Properties>`
};
sheetXmls.forEach((x,i)=>files[`xl/worksheets/sheet${i+1}.xml`]=x);
const zip=makeZip(files),blob=new Blob([zip],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),a=document.createElement('a');a.href=URL.createObjectURL(blob);a.download=filename;document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(a.href),1500);return true;
}
function accountingSubtitle(extra=''){
const cfg=typeof getAppSettings==='function'?getAppSettings():{},now=new Date();return `${cfg.sellerName||'Jūsų įmonės pavadinimas'}${cfg.sellerBrand?' · '+cfg.sellerBrand:''} · Eksportuota ${now.toLocaleString('lt-LT')}${extra?' · '+extra:''}`;
}
function purchaseSheetDefs(){
const api=window.MOGA_PURCHASES;if(!api)return[];const os=api.orders?.()||[],acc=window.MOGA_ACCOUNTING,groups=acc?.groups?.()||[];
const buckets=new Map();groups.forEach(g=>buckets.set(g.id,{group:g,rows:[]}));
const unassigned={group:{id:'',name:'Nepriskirta',sheetName:'Kiti - Pirkimai'},rows:[]};
const purchaseStatusLabel=(status)=>({
  draft:'Juodraštis',ordered:'Užsakyta',confirmed:'Patvirtinta',shipped:'Išsiųsta',
  partial:'Dalinai gauta',received:'Gauta',cancelled:'Atšaukta'
})[String(status||'').trim().toLowerCase()]||status||'';

os.filter(o=>o.status!=='cancelled').forEach(o=>{
  const calc=api.orderCalc?.(o)||{total:0};
  const sup=api.supplierNameForOrder?.(o)||o.supplierSnapshot?.name||'';
  const lines=(o.lines||[]).length?o.lines:[{name:o.reference||'Pirkimas',qty:1,receivedQty:0,unitCost:calc.total,discount:0}];

  /* Eilutės grupė turi prioritetą. Seniems PO be line.accountingGroup paliekamas
     ankstesnis elgesys: bendra PO grupė -> automatinis grupės atpažinimas. */
  const resolved=lines.map(l=>{
    const autoGroup=acc?.inferGroup?.([sup,o.reference,o.notes,l.name,l.sku,l.supplierSku].join(' '))||'';
    const groupId=l.accountingGroup||o.accountingGroup||autoGroup||'';
    return{line:l,groupId};
  });

  /* Kad vienas PO, išskaidytas per kelis Excel lapus, nerodytų visos PO sumos
     kiekviename lape, paskaičiuojame būtent tai grupei tenkančią eilučių sumą. */
  const groupTotals={};
  resolved.forEach(({line,groupId})=>{
    const qty=num(line.qty),unit=num(line.unitCost),lineSum=qty*unit*(1-num(line.discount)/100);
    groupTotals[groupId]=(groupTotals[groupId]||0)+lineSum;
  });

  resolved.forEach(({line:l,groupId})=>{
    const bucket=buckets.get(groupId)||unassigned;
    const qty=num(l.qty),unit=num(l.unitCost),lineSum=qty*unit*(1-num(l.discount)/100);
    bucket.rows.push([
      o.date||'',o.no||'',l.name||'',qty,lineSum,unit,num(l.receivedQty),
      Math.max(0,qty-num(l.receivedQty)),sup,o.reference||'',o.documentName||'',
      purchaseStatusLabel(o.status),groupTotals[groupId]||lineSum
    ]);
  });
});
const defs=[];for(const b of buckets.values()){defs.push({name:b.group.sheetName||`${b.group.name} - Pirkimai`,title:`${String(b.group.name||'PIRKIMAI').toUpperCase()} · PIRKIMAI`,subtitle:accountingSubtitle('Prekių pirkimų registras'),headers:['Data','Pirkimo Nr.','Prekė','Kiekis','Visa suma','Vieneto savikaina','Gauta','Liko','Kur pirkta / tiekėjas','Dokumento Nr.','Dokumentas','Būsena','Grupės suma šiame PO'],rows:b.rows,widths:[14,18,42,10,15,17,10,10,26,22,38,16,20],styleForRow:(row,i)=>[4,5,12].includes(i)?5:4});}
if(unassigned.rows.length)defs.push({name:unassigned.group.sheetName,title:'KITI · PIRKIMAI',subtitle:accountingSubtitle('Nepriskirti prekių pirkimai'),headers:['Data','Pirkimo Nr.','Prekė','Kiekis','Visa suma','Vieneto savikaina','Gauta','Liko','Kur pirkta / tiekėjas','Dokumento Nr.','Dokumentas','Būsena','Grupės suma šiame PO'],rows:unassigned.rows,widths:[14,18,42,10,15,17,10,10,26,22,38,16,20],styleForRow:(row,i)=>[4,5,12].includes(i)?5:4});
return defs;
}
function salesRows(){
const tracking=(typeof getTrackingInfo==='function'?getTrackingInfo():[]),products=typeof getProducts==='function'?getProducts():[];const out=[];
tracking.forEach(r=>(r.items||[]).forEach(it=>{if(!it.name)return;const p=products.find(x=>x.name===it.name)||{},qty=Number(it.qty)||0,cost=num(it.cost)||num(p.cost),price=num(it.price),disc=Math.max(0,Number(it.discount)||0),sold=price*(1-disc/100),revenue=sold*qty,profit=(sold-cost)*qty,channel=r.salesChannel||'';out.push([r.date||'',it.name,qty,cost,sold,revenue,channel,profit,'PARDUOTA',[r.order,channel].filter(Boolean).join(' | '),r.no||'',r.file||'']);}));return out;
}
function salesSheetDef(){return{name:'Pardavimai',title:'PARDAVIMAI',subtitle:accountingSubtitle('Automatiškai iš registruotų SF'),headers:['Data','Prekė','Kiekis','Savikaina/vnt','Parduota už/vnt','Pajamos','Kur parduota','Pelnas','Statusas','Pastabos','SF Nr.','Dokumentas'],rows:salesRows(),widths:[14,42,10,16,17,15,18,15,15,28,22,42],styleForRow:(row,i)=>[3,4,5,7].includes(i)?5:4};}
function incomeRows(){
const tracking=typeof getTrackingInfo==='function'?getTrackingInfo():[];
const byInvoice=new Map(),problems=[];
tracking.forEach((r,index)=>{
  const no=String(r?.no||'').trim();
  if(!no){problems.push(`Eilutė ${index+1}: nėra SF numerio.`);return;}
  const normalized={date:String(r.date||'').trim(),no,order:String(r.order||'').trim(),buyer:String(r.buyer||'').trim(),sum:num(r.sum),payment:String(r.payment||'').trim(),channel:String(r.salesChannel||'').trim(),file:String(r.file||'').trim()};
  if(!byInvoice.has(no)){byInvoice.set(no,normalized);return;}
  const prev=byInvoice.get(no);
  const conflicts=[];
  ['date','order','buyer'].forEach(k=>{if(prev[k]&&normalized[k]&&prev[k]!==normalized[k])conflicts.push(k)});
  if(Math.abs(prev.sum-normalized.sum)>0.005)conflicts.push('suma');
  if(conflicts.length)problems.push(`SF ${no}: rasti nesutampantys dublikatai (${conflicts.join(', ')}).`);
  /* Vienodas seno registro dublikatas nėra sumuojamas: viena SF visada yra viena pajamų eilutė. */
});
if(problems.length){const e=new Error('PAJAMŲ EKSPORTO APSAUGA\n'+problems.join('\n'));e.mogaIncomeProblems=problems;throw e;}
return [...byInvoice.values()].sort((a,b)=>a.date.localeCompare(b.date)||a.no.localeCompare(b.no,'lt',{numeric:true})).map(r=>[r.date,r.no,r.order,r.buyer,r.sum,r.payment,r.channel,r.file]);
}
function incomeSheetDef(){return{name:'Pajamos',title:'PAJAMOS',subtitle:accountingSubtitle('Viena SF = viena pajamų eilutė · suma imama tiesiai iš galutinės SF sumos'),headers:['Data','SF Nr.','Užsakymo Nr.','Pirkėjas','Pajamos','Mokėjimo būdas','Kanalas','Dokumentas'],rows:incomeRows(),widths:[14,22,18,30,15,22,20,42],styleForRow:(row,i)=>i===4?5:4};}
function expenseRows(){
const expenseStatusLabel=(status)=>({
  paid:'Sumokėta',
  partial:'Dalinai sumokėta',
  unpaid:'Nesumokėta'
})[String(status||'').trim().toLowerCase()]||status||'';
const api=window.MOGA_EXPENSES,arr=api?.load?.()||[];return arr.slice().sort((a,b)=>String(a.date).localeCompare(String(b.date))).map(e=>{const c=api.calc(e);return[e.date||'',e.category||'',e.notes||e.vendor||'',c.total,e.documentName||'',e.documentNo||'',e.vendor||'',expenseStatusLabel(e.status),c.net,c.vat,c.deductible];});
}
function expensesSheetDef(){return{name:'Išlaidos',title:'IŠLAIDOS',subtitle:accountingSubtitle('Veiklos išlaidų registras'),headers:['Data','Kategorija','Kas','Suma','Dokumentas','Dokumento Nr.','Tiekėjas','Būsena','Be PVM','PVM','Veiklai priskiriama'],rows:expenseRows(),widths:[14,24,42,15,42,22,28,16,15,14,18],styleForRow:(row,i)=>[3,8,9,10].includes(i)?5:4};}
function accountingSummaryDef(){
const ps=window.MOGA_PURCHASES,es=window.MOGA_EXPENSES,tracking=typeof getTrackingInfo==='function'?getTrackingInfo():[];const orders=(ps?.orders?.()||[]).filter(o=>o.status!=='cancelled'),expenses=es?.load?.()||[];
const sales=tracking.reduce((a,r)=>a+num(r.sum),0),salesCost=salesRows().reduce((a,r)=>a+num(r[2])*num(r[3]),0),purchaseTotal=orders.reduce((a,o)=>a+num(ps.orderCalc(o).total),0),expenseTotal=expenses.reduce((a,e)=>a+num(es.calc(e).total),0),gross=sales-salesCost,afterExpenses=gross-expenseTotal;
const rows=[['Pardavimai',sales],['Parduotų prekių savikaina',salesCost],['Bruto pelnas',gross],['Veiklos išlaidos',expenseTotal],['Rezultatas po veiklos išlaidų',afterExpenses],['Prekių pirkimai',purchaseTotal],['Išrašytų SF',tracking.length],['Pirkimų dokumentų',orders.length],['Išlaidų dokumentų',expenses.length],['',''],['PASTABA','Prekių pirkimai nėra antrą kartą atimami iš bruto pelno: parduotų prekių savikaina jau įtraukiama per SF prekių savikainą.']];
return{name:'Suvestinė',title:'APSKAITOS SUVESTINĖ',subtitle:accountingSubtitle('Sistema yra duomenų šaltinis · Excel yra eksportas'),headers:['Rodiklis','Reikšmė'],rows,widths:[42,70],filter:false,freeze:false,landscape:false,styleForRow:(row,i)=>['Pardavimai','Parduotų prekių savikaina','Bruto pelnas','Veiklos išlaidos','Rezultatas po veiklos išlaidų','Prekių pirkimai'].includes(row[0])&&i===1?5:4};
}
window.exportPurchasesExcel=function(){if(!window.MOGA_PLAN?.isPremium?.()){window.MOGA_PLANS_UI?.open?.('PREMIUM','Pirkimų Excel eksportas');return}const defs=purchaseSheetDefs();if(!defs.length){alert('Pirkimų eksportui dar nėra.');return false}return downloadWorkbook(defs,`MOGA_Pirkimai_${typeof backupStamp==='function'?backupStamp():new Date().toISOString().slice(0,10)}.xlsx`,'MOGA SF PREMIUM – Pirkimų Excel')};
window.exportExpensesExcel=function(){if(!window.MOGA_PLAN?.isPremium?.()){window.MOGA_PLANS_UI?.open?.('PREMIUM','Išlaidų Excel eksportas');return}const def=expensesSheetDef();if(!def.rows.length){alert('Išlaidų eksportui dar nėra.');return false}return downloadWorkbook([def],`MOGA_Islaidos_${typeof backupStamp==='function'?backupStamp():new Date().toISOString().slice(0,10)}.xlsx`,'MOGA SF PREMIUM – Išlaidų Excel')};
window.exportSalesExcel=function(){if(!window.MOGA_PLAN?.isPremium?.()){window.MOGA_PLANS_UI?.open?.('PREMIUM','Pardavimų Excel eksportas');return}const def=salesSheetDef();if(!def.rows.length){alert('Pardavimų eksportui dar nėra.');return false}return downloadWorkbook([def],`MOGA_Pardavimai_${typeof backupStamp==='function'?backupStamp():new Date().toISOString().slice(0,10)}.xlsx`,'MOGA SF PREMIUM – Pardavimų Excel')};
window.exportAccountingExcel=function(){if(!window.MOGA_PLAN?.isPremium?.()){window.MOGA_PLANS_UI?.open?.('PREMIUM','Pilna apskaita Excel');return}try{const defs=[...purchaseSheetDefs(),salesSheetDef(),incomeSheetDef(),expensesSheetDef(),accountingSummaryDef()];return downloadWorkbook(defs,`MOGA_Apskaita_${typeof backupStamp==='function'?backupStamp():new Date().toISOString().slice(0,10)}.xlsx`,'MOGA SF PREMIUM – Pilna apskaita')}catch(e){if(e?.mogaIncomeProblems){alert('Pajamų Excel nesukurtas, nes aptikta SF registro neatitikimų.\n\n'+e.mogaIncomeProblems.join('\n')+'\n\nPataisyk nurodytas SF SEKIMO INFO ir bandyk dar kartą.');return false}throw e}};

let excelPeriodConfirmed={from:false,to:false};
window.openExcelExportPeriod=function(){
const modal=document.getElementById('excelPeriodModal');
if(!modal)return;
const all=(typeof getTrackingInfo==='function'?getTrackingInfo():[]).filter(r=>r&&/^\d{4}-\d{2}-\d{2}$/.test(String(r.date||'')));
const dates=all.map(r=>String(r.date)).sort();
const from=document.getElementById('excelExportFrom');
const to=document.getElementById('excelExportTo');
// Patogus default: visas šiuo metu turimas laikotarpis.
from.value=dates[0]||new Date().toISOString().slice(0,10);
to.value=dates[dates.length-1]||new Date().toISOString().slice(0,10);
excelPeriodConfirmed={from:false,to:false};
updateExcelPeriodUi();
modal.classList.add('open');
modal.setAttribute('aria-hidden','false');
};
window.closeExcelExportPeriod=function(){
const modal=document.getElementById('excelPeriodModal');
if(modal){modal.classList.remove('open');modal.setAttribute('aria-hidden','true');}
};
window.resetExcelPeriodConfirmation=function(which){
excelPeriodConfirmed[which]=false;
updateExcelPeriodUi();
};
window.confirmExcelPeriodDate=function(which){
const id=which==='from'?'excelExportFrom':'excelExportTo';
const input=document.getElementById(id);
if(!input?.value){alert('Pirmiausia pasirink datą.');return;}
excelPeriodConfirmed[which]=true;
updateExcelPeriodUi();
};
function updateExcelPeriodUi(){
const from=document.getElementById('excelExportFrom')?.value||'';
const to=document.getElementById('excelExportTo')?.value||'';
['from','to'].forEach(which=>{
const ok=!!excelPeriodConfirmed[which];
const card=document.getElementById(which==='from'?'excelFromCard':'excelToCard');
const btn=document.getElementById(which==='from'?'excelFromConfirm':'excelToConfirm');
const status=document.getElementById(which==='from'?'excelFromStatus':'excelToStatus');
card?.classList.toggle('confirmed',ok);
btn?.classList.toggle('confirmed',ok);
if(btn)btn.textContent=ok?'PATVIRTINTA ✓':'PATVIRTINTI';
if(status)status.textContent=ok?'Data patvirtinta':'Data dar nepatvirtinta';
});
const validOrder=!from||!to||from<=to;
const unlocked=excelPeriodConfirmed.from&&excelPeriodConfirmed.to&&validOrder;
const exportBtn=document.getElementById('excelPeriodExportBtn');
if(exportBtn)exportBtn.disabled=!unlocked;
const summary=document.getElementById('excelPeriodSummary');
if(summary){
if(from&&to&&!validOrder)summary.textContent='„Nuo“ data negali būti vėlesnė už „Iki“ datą.';
else if(excelPeriodConfirmed.from&&excelPeriodConfirmed.to)summary.textContent=`Bus eksportuojamos SF nuo ${from} iki ${to}.`;
else summary.textContent='';
}
}
window.runExcelExportPeriod=async function(){
const from=document.getElementById('excelExportFrom')?.value||'';
const to=document.getElementById('excelExportTo')?.value||'';
if(!excelPeriodConfirmed.from||!excelPeriodConfirmed.to)return;
if(from>to){alert('„Nuo“ data negali būti vėlesnė už „Iki“ datą.');return;}
const ok=await exportTrackingExcel(from,to);
if(ok)closeExcelExportPeriod();
};
document.addEventListener('keydown',e=>{
if(e.key==='Escape'&&document.getElementById('excelPeriodModal')?.classList.contains('open'))closeExcelExportPeriod();
});
window.exportTrackingExcel=exportTrackingExcel;
})();